import { render, staticRenderFns } from "./LayoutLeft2.vue?vue&type=template&id=399ed272"
import script from "./LayoutLeft2.vue?vue&type=script&lang=js"
export * from "./LayoutLeft2.vue?vue&type=script&lang=js"
import style0 from "./LayoutLeft2.vue?vue&type=style&index=0&id=399ed272&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports